import { ModalProps } from 'common/common-models'
import { dateFormatOptions } from 'common/dateFormatterConfig'
import { IAgreement } from 'models/agreements'
import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import AgreementsService from 'services/agreements.service'


interface AgreementSignaturesModalProps extends ModalProps {
  agreement: IAgreement | null;
}

export default function AgreementSignaturesModal(props: AgreementSignaturesModalProps) {

  const [signatures, setSignatures] = useState<any[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);

  const requiredSigners = props.agreement?.signers ?? [];
  const signedCount = requiredSigners.filter(signer => signer.isSigned).length;

  useEffect(() => {
    if (props.agreement) {
      setLoading(true);
      AgreementsService.getAgreementSignatures(props.agreement.id).then(res => {
          setSignatures(res.signatures);
      }).finally(() => {
          setLoading(false);
      });
    }
  }, [props.agreement]);


  return (
      <Modal
        show={true}
        size={"lg"}
        onHide={props.handleModalHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Allkirjad
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            isLoading ?
            <div className="text-center"><Spinner animation={"grow"}/></div> : (
              <>
                {
                  requiredSigners.length > 0 &&
                  <div className="mb-4">
                    <h6>Nõutud allkirjastajad ({signedCount}/{requiredSigners.length})</h6>
                    {requiredSigners.map((signer, i) => (
                      <div className="row" key={signer.idCode ?? i}>
                        <div className="col-12 d-flex justify-content-between">
                          <span>{signer.name} ({signer.idCode})</span>
                          <span>
                            {signer.isSigned && signer.dateSigned
                              ? new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(signer.dateSigned))
                              : 'Allkirja ootel'}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                }
                <div>
                  <h6>Allkirjad</h6>
                  { signatures.length > 0 ?
                    signatures.map((s, i) => (
                      <div className="row" key={i}>
                        <div className="col-12">
                          {s.signer} - {new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(s.dateSigned))}
                        </div>
                      </div>
                    )) :
                    <div className="row">
                      <div className="col-12">Allkirjad puuduvad</div>
                    </div>
                  }
                </div>
              </>
            )
          }
        </Modal.Body>
      </Modal>    
  )

}